import { getLanguage } from "./root.selectors";
import { RootState } from "./root.reducer";

export const getRtl = (state: RootState): boolean =>
  getLanguage(state).inversedDirection;
